import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import PostIndexContainer from '@buyside/components/presentation/PostIndex/postIndexContainer';

import { postsUrl } from '@buyside/util/urlHelper';

const PostIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the posts">
      <Router basename={postsUrl()}>
        <PostIndexContainer />
      </Router>
    </ErrorBoundary>
  );
};

export default PostIndexPageRoot;
